import { render, staticRenderFns } from "./PbTable.vue?vue&type=template&id=f60b1894&"
import script from "./PbTable.vue?vue&type=script&lang=js&"
export * from "./PbTable.vue?vue&type=script&lang=js&"
import style0 from "./PbTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports